define('core/global/leadgen',["jquery", "core/global/state", "waypoints"], function ($, state) {
    console.log('global/leadgen');

    // This file needs to pull in some vars that are set in _Layout, so using loose module pattern coupling 
    var me = (function (ns) {

        // The sticky bar JS
        ns.stickyGlass = function() {
             
             //Find the subnav container.  Then find its parent container to calculate the pixel
             // distance from the top of the body to the top of the subnav.
             var subnav = document.querySelector('.cta-stage-glass');
             var main = document.querySelector('#main');
             var spaceAboveSubnav = main.offsetTop + subnav.offsetTop;

             function applyStickToSubnavOnDesktop() {
                 if (window.innerWidth > 1024) {
                    stickSubNav();
                } else {
                    removeClassesAndBodyPadding();
                }
             }

             function removeClassesAndBodyPadding() {
                 document.body.style.paddingTop = '0px';
                 document.body.classList.remove('is-stuck');
                 subnav.classList.remove('stuck');
             }
  
             function stickSubNav() {
                 if (window.scrollY >= spaceAboveSubnav) {
                     document.body.classList.add('is-stuck');
                     subnav.classList.add('stuck');
                     subnav.style.height = '64px';
                 } else {
                     removeClassesAndBodyPadding();
                 }
             }

            
            // Copied from subnav.js
            if (!EFTOURS.device.isTouch) {
                window.addEventListener('resize', applyStickToSubnavOnDesktop); 
                window.addEventListener('scroll', applyStickToSubnavOnDesktop);  
            }
        };
        
        // The tour page subnav JS
        ns.tourSubnav = function () {

            // Let's create the highlighting of subnav items as we scroll
            var $subnavLinks = $(".cta-stage-glass-subnav li");
            var tourName = document.querySelector(".tour-name");

            var waypoint = new Waypoint({
                element: tourName,
                handler: function (direction) {
                    if (direction === 'down') {

                    }
                },
                offset: $(".cta-stage-glass").innerHeight()

            });
            waypoint = new Waypoint({
                element: tourName,
                handler: function (direction) {
                    if (direction === 'up') {
                        if (!$("body").hasClass("is-stuck"))
                            $subnavLinks.removeClass("active");
                    }
                },
                offset: $(".cta-stage-glass").innerHeight() - 5

            });           

            // And then let's create the scrolling effect
            $(".cta-stage-glass-subnav a").on("click", function (event) {
                event.preventDefault();
                $subnavLinks.removeClass("active");
                var $thisLink = $(this).closest("li");
                var $activeLink = $($thisLink).attr("id");
                if ($activeLink != '') {
                    $subnavLinks.removeClass("active");
                    $($thisLink).addClass("active");
                }
                $('html, body').animate({ scrollTop: $($(this).attr("href")).offset().top - $(".cta-stage-glass").innerHeight()}, 1000);
            });
        };

        ns.expandoForm = function () {
            var $expandoForm = $(".expando-form .expando");
            var $expandoTrigger = $(".expando-form .expando-trigger");
            var $expandoCheckbox = $(".expando-form .expando-trigger input[type='checkbox']");
            $($expandoTrigger).on("click", function (e) {
                var $target = $(e.target);
                var isCheckbox = $target.is($expandoCheckbox);
                $expandoForm.slideToggle();
                if (!isCheckbox) {
                    e.stopPropagation();
                    e.preventDefault();
                    if ($($expandoCheckbox).is(':checked')) {
                        $($expandoCheckbox).prop("checked", false);
                    } else {
                        $($expandoCheckbox).prop("checked", true);
                    }
                }
            });
        };
        return ns;
    }(window.EFTOURS.leadgen || {}));

    return me;
});
